import { handleActions } from 'redux-actions'

import {
  getFrontendSettingRequest,
  getFrontendSettingSucceed,
  requestFailure,
  updateFrontendSettingRequest,
  updateFrontendSettingSucceed
} from './actions'

export const INITIAL_STATE = {
  processing: {
    getFrontendSetting: false,
    updatingFrontendSetting: false
  },
  frontendSetting: null
}

type State = typeof INITIAL_STATE

export const settingReducer = handleActions<State, any>(
  {
    [getFrontendSettingRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getFrontendSetting: true
      }
    }),
    [getFrontendSettingSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getFrontendSetting: false
      },
      frontendSetting: payload
    }),
    [updateFrontendSettingRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        updatingFrontendSetting: true
      },
      frontendSetting: null
    }),
    [updateFrontendSettingSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        updatingFrontendSetting: false
      },
      frontendSetting: payload
    }),
    [requestFailure.toString()]: (state) => ({
      ...state,
      processing: INITIAL_STATE.processing
    })
  },
  INITIAL_STATE
)
